<template>
  <div>
    <sweet-modal blocking :title="$t('modal_createEngagementTaskProgress')" width="780px" ref="createProjectTaskProgress" class="modal" v-on:close="close">
      <el-form label-position="left" :model="formCreateProjectTaskProgress" status-icon :rules="rules" ref="formCreateProjectTaskProgress" label-width="100px" class="demo-ruleForm">

        <template v-if="parentBill">
            <el-form-item label-width="0">
                <el-switch v-model="formCreateProjectTaskProgress.isBillable" :active-text="$t('modal_billing')"></el-switch>
            </el-form-item>

            <el-row v-if="formCreateProjectTaskProgress.isBillable" :gutter="20">
              <el-col :span="12">
                <el-form-item prop="assignmentsId" label-width="0">
                    <el-select v-model="formCreateProjectTaskProgress.assignmentsId" :placeholder="$t('modal_assignments')" clearable style="width: 100%;">
                    <el-option v-for="item in formCreateProjectTaskProgress.assignments"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        @click.native="selectAssignments(item)">
                    </el-option>
                    </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item prop="activitiesId" label-width="0">
                      <el-select v-model="formCreateProjectTaskProgress.activitiesId" :placeholder="$t('modal_activities')" clearable style="width: 100%;">
                      <el-option v-for="item in formCreateProjectTaskProgress.activities"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                      </el-select>
                  </el-form-item>
                </el-col>
            </el-row>

            <el-row v-if="formCreateProjectTaskProgress.isBillable">
                <el-col :span="24">
                <el-form-item label-width="0" prop="title">
                    <el-input v-model="formCreateProjectTaskProgress.title" :label="$t('modal_shortNote')"></el-input>
                </el-form-item>
                </el-col>
            </el-row>
        </template>

        <el-form-item class="text-block" label-position="top" label-width="0">
          <vue2-custom-editor
            ref="editor"
            style="margin-bottom: 20px;"
            v-model="formCreateProjectTaskProgress.text"/>
        </el-form-item>
        <div class="reminder-block">
          <el-form-item :label="$t('modal_timeSpent')">
            <!-- <el-time-picker
              v-model="formCreateProjectTaskProgress.timeSpent"
              value-format='HHmm'
              format='HH:mm'
              :picker-options="{
                align: 'center'
              }"
              placeholder="Arbitrary time">
            </el-time-picker> -->

            <el-input disabled placeholder="Arbitrary time" v-model="stopTime"></el-input>
          </el-form-item>

          <div class="reminder-block_date">
            <el-form-item prop="isReminderActive" :label="$t('modal_setReminder')" label-width="120px">
              <el-checkbox name="type" @change="isReminderActiveChange(formCreateProjectTaskProgress.isReminderActive)" v-model="formCreateProjectTaskProgress.isReminderActive"></el-checkbox>
            </el-form-item>
            <el-form-item prop="reminderDate" label-width="20px">
              <el-date-picker
                      format="d MMM yy h : mm A"
                      :disabled="!formCreateProjectTaskProgress.isReminderActive"
                      v-model="formCreateProjectTaskProgress.reminderDate"
                      type="datetime"
                      :placeholder="$t('modal_pickADate')"
                      value-format="timestamp"
              >
              </el-date-picker>
            </el-form-item>
          </div>
        </div>

        <el-form-item :label="$t('modal_progress')" prop="Progress" >
          <el-slider
                  v-model="formCreateProjectTaskProgress.progress"
                  :max="100"
                  :min="0"
                  :step="5"
                  show-stops>
          </el-slider>
        </el-form-item>

        <div class="flex-twocolumn">
            <el-form-item label-width="0">
              <el-switch v-model="formCreateProjectTaskProgress.notifyProjectTeam"></el-switch> {{$t('modal_notifyEngagementTeam')}}
            </el-form-item>
            <el-form-item label-width="0">
              <el-switch v-model="formCreateProjectTaskProgress.notifyTaskTeam"></el-switch> {{$t('modal_notifyTaskTeam')}}
            </el-form-item>
            <el-form-item label-width="0">
              <el-switch v-model="formCreateProjectTaskProgress.notifyClients"></el-switch> {{$t('modal_notifyClients')}}
            </el-form-item>
            <el-form-item label-width="0">
              <el-switch v-model="formCreateProjectTaskProgress.notifyVendors"></el-switch> {{$t('modal_notifyVendors')}}
            </el-form-item>
        </div>

        <div class="flex-end">
          <el-form-item class="modal__btn">
            <el-button @click="modalCancel('createProjectTaskProgress')">{{$t('general_cancel')}}</el-button>
            <el-button @click="createProjectTaskProgressSubmit('formCreateProjectTaskProgress')" type="primary">{{$t('general_submit')}}</el-button>
          </el-form-item>
        </div>

      </el-form>
    </sweet-modal>
  </div>
</template>

<script>
import Vue2CustomEditor from "../../vue-2-custom-editor";
import { SweetModal } from '@totalflow4/tfsweet-modal-vue';

import axios from 'axios';

export default {
  components: {
    SweetModal,
    Vue2CustomEditor,
  },
  props: [
    'activeProjectId',
    'stopTime',
    'progress',
    'parentBill',
    'assignmentList',
  ],
  watch:{
    progress(val){
      this.formCreateProjectTaskProgress.progress = val
    },
    stopTime(val) {
      this.formCreateProjectTaskProgress.timeSpent = val
    },
    assignmentList(val) {
      this.formCreateProjectTaskProgress.assignments = val
    },
  },
  mounted() {
    // this.createProjectTaskProgressOpen();
    this.formCreateProjectTaskProgress.progress = this.progress
  },
  data() {
    var checkDate = (rule, value, callback) => {
      if (!value && this.formCreateProjectTaskProgress.isReminderActive) {
        return callback(new Error('Please input the date'));
      }else callback();
    };
    return {

      depTaskId: 0,
      depTaskTimerId: 0,

      formCreateProjectTaskProgress: {
        isBillable: true,
        activitiesId: null,
        activities: [],
        assignmentsId: null,
        assignments: [],

        progress: 0,
        title: '',
        text: '',
        timeSpent: '0000',
        hoursSpent: 0,
        minutesSpent: 0,
        notifyProjectTeam: false,
        notifyTaskTeam: true,
        notifyClients: false,
        notifyVendors: false,
        isReminderActive: false,
        reminderDate: ''
      },
      fileList:[],
      rules: {
        reminderDate: [{ validator: checkDate, trigger: 'blur' }]
      }
    };
  },
  methods: {
    selectAssignments(item) {
      this.formCreateProjectTaskProgress.activitiesId = null
      this.formCreateProjectTaskProgress.activities = item.activities
    },
    setImagesState() {
      this.$refs.editor.setImagesState()
    },
    modalCancel(ref) {
      this.$refs[ref].close();
    },
    isReminderActiveChange(value){
      if(!value){
        this.$refs['formCreateProjectTaskProgress'].resetFields();
      }
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type,
      });
    },

    createProjectTaskProgressSubmit(form) {
      if(this.formCreateProjectTaskProgress.progress < this.progress){
        return this.notification("Notification", "Progress cannot be less", "info")
      }
      console.log('---', 'submit create');
      this.$refs[form].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show();

          if (this.formCreateProjectTaskProgress.timeSpent) {
            let time, hours, minutes;
            time = this.formCreateProjectTaskProgress.timeSpent;
            hours = time.slice(0, 2);
            minutes = time.slice(3, 5);
            this.formCreateProjectTaskProgress.hoursSpent = hours
            this.formCreateProjectTaskProgress.minutesSpent = minutes
          }
          if(this.formCreateProjectTaskProgress.reminderDate === ''){
            this.formCreateProjectTaskProgress.reminderDate = null
          }
          if (!this.formCreateProjectTaskProgress.isBillable) {
            this.formCreateProjectTaskProgress.title = ''
            this.formCreateProjectTaskProgress.activitiesId = null
            this.formCreateProjectTaskProgress.assignmentsId = null
          }
          axios
          .post(`/api/v1/engagementTaskProgresses/create?companyId=${this.$route.query.companyId}&engagementId=${this.activeProjectId}&engagementTaskId=${this.depTaskId}`, {
            title: this.formCreateProjectTaskProgress.title,
            text: this.formCreateProjectTaskProgress.text,
            progress: this.formCreateProjectTaskProgress.progress,
            notifyEngagementTeam: this.formCreateProjectTaskProgress.notifyProjectTeam,
            notifyTaskTeam: this.formCreateProjectTaskProgress.notifyTaskTeam,
            notifyClients: this.formCreateProjectTaskProgress.notifyClients,
            notifyVendors: this.formCreateProjectTaskProgress.notifyVendors,
            hoursSpent: this.formCreateProjectTaskProgress.hoursSpent,
            minutesSpent: this.formCreateProjectTaskProgress.minutesSpent,
            isReminderActive: this.formCreateProjectTaskProgress.isReminderActive,
            reminderDate: this.formCreateProjectTaskProgress.reminderDate / 1000,
            timer: true,
            isBillable: this.parentBill ? this.formCreateProjectTaskProgress.isBillable : false,
            activityId: this.formCreateProjectTaskProgress.activitiesId,
            assignmentId: this.formCreateProjectTaskProgress.assignmentsId,
          })
          .then(response => {
            if(response.data.success){
              this.notification(this.$i18n.t('notification_title_success'), this.$i18n.t('success_addProgressNote'), "success");
              if(this.$route.name === 'engagements' && this.$route.query.engagementId == this.activeProjectId && this.$route.query.taskId == this.depTaskId){
                this.$store.dispatch('getEngagementProgressesList', this.depTaskId)
              }
              if (this.$refs.editor.uploadedImagesArray.length) {
                this.$store.dispatch('approveUploadedImages', {
                  fileUrlArr: this.$refs.editor.uploadedImagesArray,
                  entityId: this.form.id,
                  entityTypeId: 39 // eng progress
                })
              }
              loader.hide()
              // this.$emit('submit')
              this.$refs.createProjectTaskProgress.close();

              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios.post(`/api/v1/engagementTaskTimers/stop?companyId=${this.$route.query.companyId}&engagementId=${this.activeProjectId}&engagementTaskId=${this.depTaskId}&engagementTaskTimerId=${this.depTaskTimerId}`)
                  .then(response => {
                      console.log('---/engagementTaskTimers/stop', response.data);
                    if(this.$route.name === 'engagements' && this.$route.query.engagementId == this.activeProjectId && this.$route.query.taskId == this.depTaskId) {
                      setTimeout(() => {
                        this.$store.dispatch('getTimerListCas', {engagementId: this.activeProjectId, engagementTaskId: this.depTaskId})
                      }, 2000);
                    }
                      this.notification("Success", "Stop", "success");
                    if(this.$route.name === 'engagements') {
                      this.$emit('submit', this.activeProjectId, this.depTaskId)
                    }
                  })
                  .catch(error => {
                      console.log('An error occurred:', error);
                  });
            }
            console.log(response)
          })
          .catch(error => {
            loader.hide()
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    close(){
      // this.formCreateProjectTaskProgress.progress = 0
      this.formCreateProjectTaskProgress.title = ''
      this.formCreateProjectTaskProgress.text = ''
      this.formCreateProjectTaskProgress.hoursSpent = 0
      this.formCreateProjectTaskProgress.minutesSpent = 0
      this.formCreateProjectTaskProgress.notifyProjectTeam = false
      this.formCreateProjectTaskProgress.notifyTaskTeam = true
      this.formCreateProjectTaskProgress.notifyClients = false
      this.formCreateProjectTaskProgress.notifyVendors = false
      this.formCreateProjectTaskProgress.reminderDate = ''
      this.formCreateProjectTaskProgress.isReminderActive = false
      this.formCreateProjectTaskProgress.timeSpent = '0000'
      this.formCreateProjectTaskProgress.isBillable = true
      this.formCreateProjectTaskProgress.activitiesId = null
      this.formCreateProjectTaskProgress.assignmentsId = null
    },
  },
};

</script>

<style lang="less" scoped>
  .modal {
    color: #000;
  }
  .text-block{
    display:flex;
    flex-direction:column;
  }
  .reminder-block{
    justify-content: space-between;
    display:flex;
    &_date{
      display:flex;
    }
  }
  .reminder-datepicker{
    margin-left:0;
  }
  .flex-twocolumn{
    display:flex;
    &_second-column{
      margin-left:20px;
    }
  }
  .flex-end{
    display:flex;
    justify-content:flex-end;
  }
  .sweet-modal-overlay{
    z-index:1000;
  }
  /*.remider{*/
    /*display:flex;*/
    /*justify-content:flex-end;*/
    /*margin-bottom:10px;*/
  /*}*/
  .upload-media{
    display:flex;
    justify-content:flex-end;
  }
</style>

<style lang="less">
  .flex-twocolumn{
    display:flex;
    .el-form-item__content{
      margin:0 12px;
      font-size:13px;
    }
  }
  .reminder-block{
    .el-date-editor.el-input{
      width: 160px;
    }
  }
</style>
